import { useState, useEffect } from "react";

const DAYS   = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
const MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];

const UtcClock = () => {
    const [utcTime, setUtcTime] = useState('');
    const [utcDate, setUtcDate] = useState('');

    useEffect(() => {
        const update = () => {
            const now = new Date();
            const h = String(now.getUTCHours()).padStart(2, '0');
            const m = String(now.getUTCMinutes()).padStart(2, '0');
            const s = String(now.getUTCSeconds()).padStart(2, '0');
            setUtcTime(`${h}:${m}:${s}Z`);
            setUtcDate(
                `${DAYS[now.getUTCDay()]} ${String(now.getUTCDate()).padStart(2,'0')} ` +
                `${MONTHS[now.getUTCMonth()]} ${now.getUTCFullYear()}`
            );
        };
        update();
        const id = setInterval(update, 1000);
        return () => clearInterval(id);
    }, []);

    return (
        <div className="ops-clock-panel">
            <div className="clock-label">ZULU TIME</div>
            <div className="clock-time">{utcTime}</div>
            <div className="clock-date">{utcDate}</div>
        </div>
    );
};

export default UtcClock;
